var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.282,
    viewBox: "0 0 16 15.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3",
    transform: "translate(-2.15 -2.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2710",
    "data-name": "Group 2710",
    transform: "translate(2.15 2.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M19.15,20.449H11.8a.65.65,0,0,1,0-1.3h7.35a.65.65,0,0,1,0,1.3Z",
    transform: "translate(-3.8 -5.167)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M15.05,2.029A2.382,2.382,0,0,1,16.735,6.1L6.526,16.3a.649.649,0,0,1-.3.171l-3.267.817a.65.65,0,0,1-.788-.788l.817-3.267a.649.649,0,0,1,.171-.3L13.366,2.726A2.366,2.366,0,0,1,15.05,2.029ZM5.734,15.258,15.816,5.177a1.083,1.083,0,0,0-1.532-1.532L4.2,13.727l-.511,2.042Z",
    transform: "translate(-2.15 -2.029)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.86cc15e7625b45bcde73303e790050cb.svg";
export { ForwardRef as ReactComponent };